export default (status: string): string => {
  switch (status) {
    case 'Active':
      return 'Deactivate';
    case 'Deleted':
      return 'Restore';
    case 'Deactivated':
      return 'Activate';
    case 'Pending':
      return 'Resend Invitation';
    case 'Locked':
      return 'Unlock';
    default:
      return '';
  }
};
